export default "__VITE_ASSET__CKBa2$ov__"